(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/divider/views/divider-sport.js') >= 0) return;  svs.modules.push('/components/content/divider/views/divider-sport.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.content=_svs.content||{};
_svs.content.divider=_svs.content.divider||{};
_svs.content.divider.templates=_svs.content.divider.templates||{};
svs.content.divider.templates.divider_sport = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3=container.escapeExpression;

  return alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"stryktipset"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"europatipset"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"topptipset"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"maltipset"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"oddset"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"challenge"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"powerplay"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"bomben"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"matchen"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"bingo"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"poker"},"data":data}))
    + "\n"
    + alias3((helpers.ui || (depth0 && depth0.ui) || alias2).call(alias1,"brands",{"name":"ui","hash":{"square":true,"brand":"casino"},"data":data}));
},"useData":true});
Handlebars.partials['components-content-divider-divider_sport'] = svs.content.divider.templates.divider_sport;
})(svs, Handlebars);

 })(window);